import { render, staticRenderFns } from "./review-application.vue?vue&type=template&id=b14711d6"
import script from "./review-application.vue?vue&type=script&lang=js"
export * from "./review-application.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports